import { render, staticRenderFns } from "./SampleResultsNest.vue?vue&type=template&id=396f02e8"
import script from "./SampleResultsNest.vue?vue&type=script&lang=js"
export * from "./SampleResultsNest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports